import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.less'
import 'swiper/css'

import Routing from './routing/Routing'
import { BrowserRouter } from 'react-router-dom'
import { setDefaultBreakpoints } from 'react-socks'
import { APISetter } from './shahrzad-assets/shared-api/api-setter'
import { BaseContext } from './shahrzad-assets/shared-contexts'
import App from './App'
import info from '../info.json';

APISetter()

export const breakPoints = setDefaultBreakpoints([
  { xsmall: 0 }, // all mobile devices
  { small: 576 }, // mobile devices (not sure which one's this big)
  { medium: 900 }, // ipad, ipad pro, ipad mini, etc
  { large: 900 }, // smaller laptops
  { xlarge: 1200 }, // laptops and desktops
])

import * as Sentry from "@sentry/react";
import { Integrations } from '@sentry/tracing'


Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  autoSessionTracking: true,
  integrations: [
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

Sentry.setTag('version', info.version);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <BrowserRouter>
      <BaseContext>
        <App />
      </BaseContext>
    </BrowserRouter>
  // </React.StrictMode>,
)
